import GlowBar from 'components/GlowBar';
import MainBurgerMenuContent from 'components/layout/header/main-burger-menu-content/MainBurgerMenuContent';
import PrizesBurgerMenuContent from 'components/layout/header/main-burger-menu-content/PrizesBurgerMenuContent';
import SubcategoriesBurgerMenuContent from 'components/layout/header/main-burger-menu-content/SubcategoriesBurgerMenuContent';
import Separator from 'components/Separator';
import $ from 'jquery';
import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import 'node_modules/react-image-gallery/styles/css/image-gallery.css';
import PrizeFilterOptions from 'prizes/weekly-draw/PrizeFilterOptions';
import { useEffect, useRef, useState } from 'react';
import { getCta, scrollToSection } from 'utils/common';
import {
  ASSET_PREFIX,
  colors,
  Cta,
  useChristmasLogos,
  useHalloweenLogos,
} from 'utils/constants';
import RoundedButton, { ColorStyle } from '../../RoundedButton';
import AnnouncementBanners from './AnnouncementBanners';

// This image-gallery.css import is weird. It may be in the header because the CSS had to be included on every page. This import was here before DRIP.
import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';
// import SearchPanel from 'components/layout/header/SearchPanel/SearchPanel';
import { PlasmicComponent } from '@plasmicapp/loader-nextjs';
import { useDrawStore } from 'hooks/stores/useDrawStore';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useHeaderContent } from 'hooks/ui/useHeaderContent';
import { MOBILE_WIDTH, useIsMobile } from 'hooks/ui/useIsMobile';
import { observer } from 'mobx-react-lite';
import { doABTest } from 'utils/analytics/abtest';
import { trackEvent } from 'utils/analytics/analytics';
import { AccountMenu } from '../account/AccountMenu';
import { ScrollableComponent } from '../ScrollableComponent';
import { AccountHeaderIcon } from './AccountHeaderIcon';
import { HeaderIconWithBadge } from './HeaderIconWithBadge';

/** A list of page path regexs that have a CTA above the fold, and the approximate location of the CTA down the page when
 * viewed on mobile. We use these to hide the header CTA until the page has scrolled passed that point for those pages
 */
const pagesWithCtasAboveTheFold = [
  [/^\/$/, 450],
  [/^\/how-it-works\/?$/, 600],
  [/^\/winners\/?$/, 800],
  [/^\/prizes\/details\/.*$/, 600],
];

const SocialMediaLinks = () => (
  <div
    className="socialMediaLinks"
    style={{ margin: '2em auto 1em', textAlign: 'center' }}
  >
    <a
      href="https://www.facebook.com/daymadeuk/"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src={`${ASSET_PREFIX}/images/social-media-icons/facebook-circle.svg`}
        alt="Facebook"
      />
    </a>

    <a
      href="https://www.instagram.com/daymadeuk/"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src={`${ASSET_PREFIX}/images/social-media-icons/instagram-circle.svg`}
        alt="Instagram"
      />
    </a>

    <a
      href="https://www.youtube.com/channel/UCUVOk8dVM_mu-1qgKwtn9HA"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src={`${ASSET_PREFIX}/images/social-media-icons/youtube-circle.svg`}
        alt="YouTube"
      />
    </a>

    <a
      href="https://www.tiktok.com/@daymadeuk"
      target="_blank"
      rel="noreferrer"
    >
      <img
        src={`${ASSET_PREFIX}/images/social-media-icons/tiktok-circle.svg`}
        alt="TikTok"
      />
    </a>

    <style>
      {`
        .socialMediaLinks img {
          width: 28px;
          height: 28px;
          margin: 0 0.5em;
        }
      `}
    </style>
  </div>
);

const ExpandableMenu = {
  MAIN_BURGER: 0,
  ACCOUNT: 1,
  PRIZES: 2,
  GAMES: 3,
  ABOUT_US: 4,
  SEARCH: 5,
};

export const BurgerMenuContent = {
  MAIN_MENU: 0,
  ALL_PRIZES: 1,
  TRIPS_AND_STAYS: 2,
  EXPERIENCES: 3,
  LIFESTYLE: 4,
  TECH: 5,
  FAMILY: 6,
  ABOUT_US: 7,
};

const HeaderStyle = {
  ORIGINAL: 0,
  STRONGER: 1,
};

const enterCtaHandlerForPathname = (pathname) => {
  if (pathname.startsWith('/iceland-raffle')) {
    return null;
  } else if (pathname === '/') {
    return () => {
      if ($('#entryMethodSelectionSection').length > 0) {
        scrollToSection('#entryMethodSelectionSection');
      } else {
        Router.push(getCta().url);
      }
    };
  } else {
    return () => Router.push(getCta().url); // Weekly Draw default
  }
};

const TokenTownHeaderIcon = observer(({ white }) => {
  const { currentUser, balances } = useUserStore();
  if (!currentUser) {
    return null;
  }

  return (
    <div className="hideOnVerySmallScreens">
      <Link href="/token-town">
        <a>
          <HeaderIconWithBadge
            iconImage={`${ASSET_PREFIX}/images/header/token-town-icon${
              white ? '-white' : ''
            }.svg`}
            iconImageAlt="Token Town icon"
            badgeNumber={balances?.tokenBalance}
          />
        </a>
      </Link>
      <style jsx>
        {`
          .hideOnVerySmallScreens {
            display: none;
          }

          @media (min-width: 365px) {
            .hideOnVerySmallScreens {
              display: inline-block;
            }
          }
        `}
      </style>
    </div>
  );
});

const Header = observer(({ staticHeader, noDropShadow, hideOnMobile }) => {
  const { displayToast, headerBanner } = useUIStore();
  const { isReferralFlow } = useEnterStore();

  const { upcomingDrawDate } = useDrawStore();

  const { showDrawCounter, showUpNext, showOrderSummary } = useHeaderContent();
  const { currentUser, logout, subscriptionStatus } = useUserStore();
  const router = useRouter();
  // We must use asPath rather than pathname, since pathname will show us the catchall path
  const routerCurrentPath = router.asPath.split('?')[0];

  const { isMobile } = useIsMobile();
  const [isChristmas] = useState(useChristmasLogos());

  const icelandRafflePage = routerCurrentPath.startsWith('/iceland-raffle');
  const enterPage =
    routerCurrentPath.startsWith('/enter') ||
    routerCurrentPath.startsWith('/choose-your-plan');
  const upgradePage = routerCurrentPath.startsWith(
    '/account/subscriptions/upgrade',
  );
  const confirmationPage = routerCurrentPath.includes('confirmation');
  const isRegisterOrLoginPage =
    routerCurrentPath == '/register' || routerCurrentPath == '/login';
  const isPlasmic = router.pathname.includes('/[...catchall]');

  const [bannerHeight, setBannerHeight] = useState(headerBanner ? 69 : 0);
  const [HEADER_HEIGHT, setHeaderHeight] = useState(
    `${(isPlasmic ? 84 : 76) + bannerHeight}px`,
  ); // Hardcoded to avoid janking on page load when we dynamically push content down.

  const challengerPage = routerCurrentPath.startsWith('/free-daily-draw');
  const tokenTownPage = routerCurrentPath.includes('/token-town');
  const christmasTravelRafflePage = routerCurrentPath.startsWith(
    '/christmas-travel-raffle',
  );
  const spinToWinPage = routerCurrentPath.startsWith('/spin-to-win');

  const loggedIn = currentUser && currentUser.id;
  const [previouslyLoggedIn, setPreviouslyLoggedIn] = useState(true);

  const [expandedMenu, setExpandedMenu] = useState(null);
  const menuOpen = expandedMenu !== null;
  const [hoveringOverHeader, setHoveringOverHeader] = useState(false);

  const [_, setForceRefresh] = useState(0);

  const [withStickyEnterNowVariant, setWithStickyEnterNowVariant] =
    useState(false);
  useEffect(() => {
    const variant = doABTest('StickyEnterNow', ['Y', 'N']);

    setWithStickyEnterNowVariant(variant == 'Y');
  }, []);

  const [selectedMainBurgerMenuContent, setSelectedMainBurgerMenuContent] =
    useState(BurgerMenuContent.MAIN_MENU);
  const [centerBarLinksVisible, setCenterBarLinksVisible] = useState(false);

  const showHeaderCTARef = useRef(false);
  showHeaderCTARef.current =
    isMobile &&
    !loggedIn &&
    !enterPage &&
    !isRegisterOrLoginPage &&
    !tokenTownPage &&
    !upgradePage &&
    !icelandRafflePage &&
    !confirmationPage &&
    !expandedMenu &&
    !christmasTravelRafflePage &&
    !spinToWinPage;

  const welcomeBackPlanName =
    currentUser?.subscriberStatus === 'PREMIUM'
      ? 'Premium'
      : currentUser?.subscriberStatus === 'LITE'
        ? 'Lite'
        : currentUser?.subscriberStatus === 'FREEMIUM'
          ? 'Free'
          : null;

  const enterCtaHandler = enterCtaHandlerForPathname(routerCurrentPath);
  const enterCtaColorStyle = icelandRafflePage
    ? ColorStyle.Iceland
    : ColorStyle.Primary;
  const defaultCTA = subscriptionStatus
    ? Cta[currentUser.subscriberStatus]
    : Cta.NON_SUBSCRIBER;
  const homePage = routerCurrentPath === '/';
  const useDefaultCTA =
    !routerCurrentPath.startsWith('/token-town/pound-raffle') &&
    !routerCurrentPath.startsWith('/token-town/free-daily-draw') &&
    !routerCurrentPath.startsWith('/iceland-raffle') &&
    !(homePage && !subscriptionStatus);

  const simplifiedDesktopHeader = enterPage || homePage;

  const headerStyle = HeaderStyle.ORIGINAL;
  const strongerHeaderStyle = headerStyle === HeaderStyle.STRONGER;
  const [isHeaderTransparent, setIsHeaderTransparent] =
    useState(strongerHeaderStyle);
  const HOME_PAGE_BREAK_POINT = 990;

  const handleDismissExpandedMenu = () => {
    setExpandedMenu(null);
    setSelectedMainBurgerMenuContent(BurgerMenuContent.MAIN_MENU); // Reset to main menu content if burger menu is closed;
  };

  const handleExpandMenu = (menu) => {
    if (expandedMenu === menu) {
      // Deselect
      handleDismissExpandedMenu();
      trackEvent('Popover Closed');
    } else {
      setExpandedMenu(menu);

      const menuName = menu === ExpandableMenu.ACCOUNT ? 'Account' : 'Menu';
      trackEvent(menuName + ' Popover Opened');
    }
  };

  useEffect(() => {
    if (menuOpen || hoveringOverHeader) {
      setIsHeaderTransparent(false);
    } else if ($(window).scrollTop() <= 150 && strongerHeaderStyle) {
      setIsHeaderTransparent(true);
    }
  }, [menuOpen, strongerHeaderStyle, hoveringOverHeader]);

  useEffect(() => {
    setHeaderHeight(`${(isPlasmic ? 84 : 76) + bannerHeight}px`);
  }, [bannerHeight]);

  useEffect(() => {
    // Hide menu when any link is clicked.
    $(
      '.headerContent a, .categoryContainer, .gameContainer, .gameLink, .expandableMenu .unclaimedPrizesCard, .accountMenuStatsContainer, .statWithImage, .smallProfileImage, .expandableMenu a, .menuLink, .subSectionLink, .expandableMenu .roundedButton, .covidBlogPostLink, .upgradeCard',
    ).on('click', (e) => {
      // Fixes bug where menu was not hidden after clicking the header link again (desktop).
      if (e.target.classList.contains('desktopHeaderLink')) return;
      handleDismissExpandedMenu();
    });

    setPreviouslyLoggedIn(
      typeof localStorage !== 'undefined' &&
        localStorage.getItem('previously_logged_in') === 'true',
    );
    return () => {
      $(
        '.headerContent a, .categoryContainer, .gameContainer, .gameLink, .expandableMenu .unclaimedPrizesCard, .accountMenuStatsContainer, .statWithImage, .smallProfileImage, .expandableMenu a, .menuLink, .subSectionLink, .expandableMenu .roundedButton, .covidBlogPostLink, .upgradeCard',
      ).off('click');
    };
  }, [selectedMainBurgerMenuContent]);

  useEffect(() => {
    if (strongerHeaderStyle) $('.desktopEnterNowButton').hide(0);

    const updateHeaderCtaBasedOnScrollPosition = function () {
      const showHeaderCTA = showHeaderCTARef.current;

      const pageAboveFoldCtaLocationY = pagesWithCtasAboveTheFold.find((x) =>
        x[0].test(routerCurrentPath),
      )?.[1];
      // If a page has a CTA above the fold, and we're showing the header CTA, wait until we've scrolled far enough
      const scrolledFarEnough =
        pageAboveFoldCtaLocationY != undefined
          ? $(this).scrollTop() > pageAboveFoldCtaLocationY
          : // Otherwise, the pay does not have a CTA above the folder, so always show the header CTA, if showHeaderCTA is
            // true
            true;
      if (scrolledFarEnough) {
        if (showHeaderCTA) {
          setCenterBarLinksVisible(true);
          // Show the logo without the name, and the header CTA button
          $('.barLinks.mobile>.leftBarLinks .withoutName').css({
            display: 'flex',
          });
          $('.barLinks.mobile>.leftBarLinks .withName').css({
            display: 'none',
          });
        } else {
          // Show the logo with the name, but with no header CTA button
          $('.barLinks.mobile>.leftBarLinks .withoutName').css({
            display: 'none',
          });
          $('.barLinks.mobile>.leftBarLinks .withName').css({
            display: 'flex',
          });
        }
        if (strongerHeaderStyle) {
          $('.desktopEnterNowButton').show(0);
          setIsHeaderTransparent(false);
        }
      } else {
        // show the logo with the name, as we haven't scrolled down far enough
        setCenterBarLinksVisible(false);
        $('.barLinks.mobile>.leftBarLinks .withoutName').css({
          display: 'none',
        });
        $('.barLinks.mobile>.leftBarLinks .withName').css({
          display: 'flex',
        });

        if (strongerHeaderStyle) {
          $('.desktopEnterNowButton').hide(0);
          setIsHeaderTransparent(true);
        }
        $('.barLinks.mobile .clippedLogoForHeaderButton').hide();
        $('.barLinks.mobile .fullLogo').show();
      }
    };
    $(window).scroll(updateHeaderCtaBasedOnScrollPosition);
    updateHeaderCtaBasedOnScrollPosition(window);

    // Toggle the transparent header on mouse hover
    if (strongerHeaderStyle) {
      $('.headerContent').on('mouseenter', (e) => {
        setHoveringOverHeader(true);
      });

      $('.headerContent').on('mouseleave', (e) => {
        setHoveringOverHeader(false);
      });
    }

    // Header.js is poorly written. It stores variables derived off the current path outside of a ref. Therefore, we
    // have to use a setState to force it to refresh
    setForceRefresh((prev) => prev + 1);

    return () => {
      if (strongerHeaderStyle) {
        $('.headerContent').off('mouseenter');
        $('.headerContent').off('mouseleave');
      }
      $(window).off('scroll', updateHeaderCtaBasedOnScrollPosition);
    };
  }, [routerCurrentPath]);

  const getPrizeFilterOptionForBurgerMenuContent = (burgerMenuContent) => {
    switch (burgerMenuContent) {
      case BurgerMenuContent.TRIPS_AND_STAYS:
        return PrizeFilterOptions.find(
          (option) => option.id === 'trips-and-stays',
        );
      case BurgerMenuContent.EXPERIENCES:
        return PrizeFilterOptions.find((option) => option.id === 'experiences');
      case BurgerMenuContent.LIFESTYLE:
        return PrizeFilterOptions.find(
          (option) => option.id === 'lifestyle-and-beauty',
        );
      case BurgerMenuContent.TECH:
        return PrizeFilterOptions.find((option) => option.id === 'tech');
      case BurgerMenuContent.FAMILY:
        return PrizeFilterOptions.find((option) => option.id === 'family');
    }
  };

  let mainBurgerMenuContent = null;
  switch (selectedMainBurgerMenuContent) {
    case BurgerMenuContent.MAIN_MENU: {
      mainBurgerMenuContent = <MainBurgerMenuContent loggedIn={loggedIn} />;
      break;
    }

    case BurgerMenuContent.ALL_PRIZES: {
      mainBurgerMenuContent = (
        <PrizesBurgerMenuContent
          onSetSelectedMainBurgerMenuContent={setSelectedMainBurgerMenuContent}
          onClickBack={
            expandedMenu === ExpandableMenu.PRIZES
              ? null // if this content is being shown under the PRIZES top-level menu (i.e. not in the burger menu) then don't show back button
              : () => {
                  setSelectedMainBurgerMenuContent(BurgerMenuContent.MAIN_MENU);
                }
          }
        />
      );
      break;
    }

    case BurgerMenuContent.TRIPS_AND_STAYS:
    case BurgerMenuContent.EXPERIENCES:
    case BurgerMenuContent.LIFESTYLE:
    case BurgerMenuContent.TECH:
    case BurgerMenuContent.FAMILY: {
      const prizeFilterOption = getPrizeFilterOptionForBurgerMenuContent(
        selectedMainBurgerMenuContent,
      );
      mainBurgerMenuContent = (
        <SubcategoriesBurgerMenuContent
          prizeFilterOption={prizeFilterOption}
          onClickBack={() =>
            setSelectedMainBurgerMenuContent(BurgerMenuContent.ALL_PRIZES)
          }
        />
      );
      break;
    }
  }

  return (
    <>
      <div
        className={
          'headerContainer ' +
          (staticHeader ? ' withStaticHeader' : '') +
          (noDropShadow ? ' withNoDropShadow' : '') +
          (hideOnMobile ? ' hideOnMobile' : '')
        }
      >
        <AnnouncementBanners
          headerBanner={headerBanner}
          onHeightChange={(height) => setBannerHeight(height)}
        />

        <div className="headerBackground">
          <div className="headerContent">
            <div className="barLinks desktop">
              <div className="leftBarLinks">
                <Link href="/?redirect=false">
                  <a className={'fullLogo'} style={{ textAlign: 'left' }}>
                    <img
                      src={`${ASSET_PREFIX}/images/daymade-logo${
                        isHeaderTransparent ? '-white' : ''
                      }${isChristmas ? '-xmas' : ''}${
                        useHalloweenLogos() ? '-halloween' : ''
                      }.png`}
                      className="logoImage"
                      alt="DAYMADE logo"
                    />
                  </a>
                </Link>
              </div>

              <div className="rightBarLinks">
                {loggedIn ? (
                  <>
                    <Link href="/account/referrals">
                      <a
                        className="desktopHeaderLink"
                        style={{
                          padding: '6px 10px',
                          border: `2px solid ${
                            isHeaderTransparent
                              ? 'white'
                              : colors.primaryBrandGray
                          }`,
                          borderRadius: '17.5px',
                          display:
                            'none' /* ENG-1060 - Referrals temporarily disabled */,
                        }}
                      >
                        {/* ENG-1060 - Referrals temporarily disabled REFER & EARN £12*/}
                      </a>
                    </Link>

                    <TokenTownHeaderIcon white={isHeaderTransparent} />

                    <div
                      style={{ cursor: 'pointer', position: 'relative' }}
                      onClick={() => {
                        handleExpandMenu(ExpandableMenu.ACCOUNT);
                      }}
                    >
                      {expandedMenu === ExpandableMenu.ACCOUNT ? (
                        <HeaderIconWithBadge
                          iconImage={`${ASSET_PREFIX}/images/header/close-menu-icon${
                            isHeaderTransparent ? '-white' : ''
                          }.svg`}
                          iconImageAlt="close menu"
                        />
                      ) : (
                        <AccountHeaderIcon white={isHeaderTransparent} />
                      )}
                    </div>

                    <div
                      style={{ cursor: 'pointer', position: 'relative' }}
                      onClick={() => {
                        handleExpandMenu(ExpandableMenu.MAIN_BURGER);
                      }}
                    >
                      <HeaderIconWithBadge
                        iconImage={`${ASSET_PREFIX}/images/header/${
                          expandedMenu === ExpandableMenu.MAIN_BURGER
                            ? 'close-menu-icon'
                            : 'main-burger-menu-icon'
                        }${isHeaderTransparent ? '-white' : ''}.svg`}
                        iconImageAlt={
                          expandedMenu === ExpandableMenu.MAIN_BURGER
                            ? 'close menu'
                            : 'open main menu'
                        }
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <Link href="/how-it-works">
                      <a className="desktopHeaderLink">How It Works</a>
                    </Link>

                    <Link href="/prizes">
                      <a className="desktopHeaderLink">Prizes</a>
                    </Link>

                    <Link href="/winners">
                      <a className="desktopHeaderLink">Winners</a>
                    </Link>

                    <Link href="/giving-back">
                      <a className="desktopHeaderLink">Plant Trees</a>
                    </Link>

                    {strongerHeaderStyle && (
                      <Link href="/faq">
                        <a className="desktopHeaderLink">FAQ</a>
                      </Link>
                    )}

                    <TokenTownHeaderIcon white={isHeaderTransparent} />

                    {loggedIn && (
                      <div
                        style={{
                          cursor: 'pointer',
                          position: 'relative',
                          width: 40,
                        }}
                        onClick={() => {
                          handleExpandMenu(ExpandableMenu.ACCOUNT);
                        }}
                      >
                        {expandedMenu === ExpandableMenu.ACCOUNT ? (
                          <HeaderIconWithBadge
                            iconImage={`${ASSET_PREFIX}/images/header/close-menu-icon${
                              isHeaderTransparent ? '-white' : ''
                            }.svg`}
                            iconImageAlt="close menu"
                          />
                        ) : (
                          <AccountHeaderIcon white={isHeaderTransparent} />
                        )}
                      </div>
                    )}

                    {previouslyLoggedIn && (
                      <div
                        style={{ cursor: 'pointer', position: 'relative' }}
                        onClick={() => {
                          handleExpandMenu(ExpandableMenu.MAIN_BURGER);
                        }}
                      >
                        <HeaderIconWithBadge
                          iconImage={`${ASSET_PREFIX}/images/header/${
                            expandedMenu === ExpandableMenu.MAIN_BURGER
                              ? 'close-menu-icon'
                              : 'main-burger-menu-icon'
                          }${isHeaderTransparent ? '-white' : ''}.svg`}
                          iconImageAlt={
                            expandedMenu === ExpandableMenu.MAIN_BURGER
                              ? 'close menu'
                              : 'open main menu'
                          }
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="barLinks mobile">
              <div className="leftBarLinks flex">
                <Link href="/?redirect=false">
                  <a
                    style={{ flexGrow: 1, position: 'relative' }}
                    className={'withName'}
                  >
                    <img
                      id="mobileLogo"
                      src={`${ASSET_PREFIX}/images/daymade-logo${
                        isHeaderTransparent ? '-white' : ''
                      }${isChristmas ? '-xmas' : ''}${
                        useHalloweenLogos() ? '-halloween' : ''
                      }.png`}
                      className="logoImage"
                      alt="DAYMADE logo"
                    />
                  </a>
                </Link>
                <Link href="/">
                  <a
                    className={
                      'withoutName' +
                      (useHalloweenLogos() ? ' withHalloween' : '') +
                      (useChristmasLogos() ? ' withChristmas' : '')
                    }
                  >
                    <img
                      id="mobileLogo"
                      src={`${ASSET_PREFIX}/images/daymade-logo${
                        isHeaderTransparent ? '-white' : ''
                      }${isChristmas ? '-xmas' : ''}${
                        useHalloweenLogos() ? '-halloween' : ''
                      }.png`}
                      className="logoImage"
                      alt="DAYMADE logo"
                    />
                  </a>
                </Link>
              </div>

              {showHeaderCTARef.current && !useDefaultCTA && (
                <div
                  className={
                    'centerBarLinks ' +
                    (centerBarLinksVisible ? 'centerBarLinksVisible' : '')
                  }
                >
                  <RoundedButton
                    onClick={enterCtaHandler}
                    colorStyle={enterCtaColorStyle}
                  >
                    Enter Now
                  </RoundedButton>
                </div>
              )}

              {showHeaderCTARef.current && useDefaultCTA && defaultCTA && (
                <div
                  className={
                    'centerBarLinks ' +
                    (centerBarLinksVisible ? 'centerBarLinksVisible' : '')
                  }
                >
                  <RoundedButton
                    onClick={() => Router.push(defaultCTA.url)}
                    colorStyle={enterCtaColorStyle}
                  >
                    {defaultCTA.label}
                  </RoundedButton>
                </div>
              )}

              <div className="rightBarLinks">
                {isMobile &&
                !isReferralFlow &&
                (showOrderSummary || showUpNext || showDrawCounter) ? (
                  <>
                    {showOrderSummary && (
                      <PlasmicComponent
                        forceOriginal
                        component="Multi Step Order Summary"
                        componentProps={{
                          variants: {
                            button: 'initial',
                          },
                        }}
                      />
                    )}

                    {showDrawCounter && (
                      <PlasmicComponent
                        forceOriginal
                        component="Draw Countdown"
                        componentProps={{
                          targetTimeUtc: upcomingDrawDate,
                          variant: 'variant2',
                        }}
                      />
                    )}

                    {showUpNext?.trim() && (
                      <PlasmicComponent
                        forceOriginal
                        component="Up Next"
                        componentProps={{
                          text: showUpNext,
                        }}
                      />
                    )}
                  </>
                ) : (
                  <>
                    {loggedIn && (
                      <>
                        <TokenTownHeaderIcon white={isHeaderTransparent} />
                        <div
                          style={{ cursor: 'pointer', position: 'relative' }}
                          onClick={() => {
                            handleExpandMenu(ExpandableMenu.ACCOUNT);
                          }}
                        >
                          {expandedMenu === ExpandableMenu.ACCOUNT ? (
                            <HeaderIconWithBadge
                              iconImage={`${ASSET_PREFIX}/images/header/close-menu-icon${
                                isHeaderTransparent ? '-white' : ''
                              }.svg`}
                              iconImageAlt="close menu"
                            />
                          ) : (
                            <AccountHeaderIcon white={isHeaderTransparent} />
                          )}
                        </div>
                      </>
                    )}
                    <div
                      style={{ cursor: 'pointer', position: 'relative' }}
                      onClick={() => {
                        handleExpandMenu(ExpandableMenu.MAIN_BURGER);
                      }}
                    >
                      <HeaderIconWithBadge
                        iconImage={`${ASSET_PREFIX}/images/header/${
                          expandedMenu === ExpandableMenu.MAIN_BURGER
                            ? 'close-menu-icon'
                            : 'main-burger-menu-icon'
                        }${isHeaderTransparent ? '-white' : ''}.svg`}
                        iconImageAlt={
                          expandedMenu === ExpandableMenu.MAIN_BURGER
                            ? 'close menu'
                            : 'open main menu'
                        }
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          {isHeaderTransparent ||
          noDropShadow ||
          (staticHeader && isMobile) ? null : (
            <GlowBar color="rgba(0, 0, 0, 0.1)" />
          )}
        </div>

        <div
          className={
            expandedMenu === ExpandableMenu.MAIN_BURGER
              ? 'expandableMenu'
              : 'expandableMenu hidden'
          }
        >
          <ScrollableComponent
            isOpen={expandedMenu === ExpandableMenu.MAIN_BURGER}
            maxHeight={'max-h-[80vh] '}
          >
            <Separator
              style={{
                width: '98%',
                margin: 0,
                height: '2px',
              }}
            />

            {mainBurgerMenuContent}

            {!challengerPage && !useDefaultCTA && (
              <RoundedButton
                onClick={enterCtaHandler}
                colorStyle={enterCtaColorStyle}
                className="enterButton hideOnWideWidth"
              >
                Enter Now
              </RoundedButton>
            )}

            {!challengerPage && useDefaultCTA && defaultCTA && (
              <RoundedButton
                onClick={() => Router.push(defaultCTA.url)}
                colorStyle={enterCtaColorStyle}
                className="enterButton hideOnWideWidth"
              >
                {defaultCTA.label}
              </RoundedButton>
            )}

            <SocialMediaLinks />
          </ScrollableComponent>
        </div>

        <div
          className={
            expandedMenu === ExpandableMenu.ACCOUNT
              ? 'expandableMenu rightAligned'
              : 'expandableMenu rightAligned hidden'
          }
        >
          <ScrollableComponent
            isOpen={expandedMenu === ExpandableMenu.ACCOUNT}
            maxHeight={'max-h-[80vh] '}
          >
            {!loggedIn ? (
              <div className="flexCentered">
                <Separator
                  style={{
                    width: '98%',
                    margin: '0 0 1em',
                    height: '2px',
                  }}
                />
                <div className="flexLeftAligned fullWidth">
                  <Link href="/login">
                    <a className="menuLink">Sign in</a>
                  </Link>

                  <Link href="/register">
                    <a className="menuLink">Register</a>
                  </Link>
                </div>
              </div>
            ) : (
              <AccountMenu
                currentUser={currentUser}
                welcomeBackPlanName={welcomeBackPlanName}
                handleNavigate={() => {
                  setExpandedMenu(null);
                }}
                signOutOnClick={() => {
                  logout();
                }}
              />
            )}

            {!challengerPage && !useDefaultCTA && (
              <RoundedButton
                onClick={enterCtaHandler}
                className="enterButton hideOnWideWidth"
                colorStyle={enterCtaColorStyle}
              >
                Enter Now
              </RoundedButton>
            )}
            {!challengerPage && useDefaultCTA && defaultCTA && (
              <RoundedButton
                onClick={() => Router.push(defaultCTA.url)}
                colorStyle={enterCtaColorStyle}
                className="enterButton hideOnWideWidth"
              >
                {defaultCTA.label}
              </RoundedButton>
            )}
            <SocialMediaLinks />
          </ScrollableComponent>
        </div>

        {/* <div
          className={
            expandedMenu === ExpandableMenu.SEARCH
              ? 'searchPanel expandableMenu rightAligned'
              : 'expandableMenu rightAligned hidden'
          }
        >
          <Separator
            style={{
              width: '100%',
              margin: 0,
              height: '2px',
            }}
          />

          <SearchPanel
            open={expandedMenu === ExpandableMenu.SEARCH}
            closePanel={handleDismissExpandedMenu}
          />
        </div> */}
      </div>
      <div
        className={
          'contentPadder' +
          (staticHeader ? ' withStaticHeader' : '') +
          (hideOnMobile ? ' hideOnMobile' : '')
        }
        style={{ height: HEADER_HEIGHT }}
      />
      <style jsx>{`
        .headerContainer {
          width: 100%;
          position: fixed;
          height: ${HEADER_HEIGHT};
          z-index: 998;
        }
        @media (max-width: 767px) {
          .headerContainer.withStaticHeader {
            position: relative;
            z-index: 5; /* Need to go behind the loadingOverlay */
          }
          .contentPadder.withStaticHeader {
            display: none;
          }
          .withStaticHeader #mobileLogo {
            position: absolute;
            top: 50%;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
          }
        }
        @media (max-width: 380px) {
          .withStaticHeader #mobileLogo {
            left: 16px;
            transform: translateX(0%) translateY(-50%);
          }
        }

        :global(.headerContainer a) {
          text-decoration: none !important;
        }

        .headerBackground {
          width: 100%;
          background-color: ${isHeaderTransparent ? 'transparent' : 'white'};
        }

        .headerBackground.withButton {
          background-color: white;
        }

        .headerContent {
          width: 100%;
          max-width: var(--dm2025-siteMaxWidth);
          margin-left: auto;
          margin-right: auto;
          display: flex;
          padding: 12px var(--dm2025-sitePadding);
          font-weight: 600;
          height: 100%;
        }

        .leftBarLinks,
        .centerBarLinks,
        .rightBarLinks {
          display: flex;
          flex: 1;
          align-items: center;
        }

        .leftBarLinks {
          justify-content: flex-start;
        }

        .centerBarLinks {
          justify-content: center;
          pointer-events: auto;
        }

        .rightBarLinks {
          justify-content: flex-end;
        }

        .barLinks.desktop {
          display: flex;
          min-height: 66px;
        }

        .barLinks.mobile {
          display: none;
        }

        @media (max-width: ${
          simplifiedDesktopHeader
            ? /* burger menu on enter/home page to reduce distractions */ '3000px'
            : `${HOME_PAGE_BREAK_POINT}px`
        }) {
          .barLinks.desktop {
            display: none;
          }

          .barLinks.mobile {
            display: flex;
            min-height: 59px;
          }
        }

        .hiddenOnMobile {
          display: none;
        }

        @media (min-width: ${MOBILE_WIDTH.toString()}px) {
          .hideDesktop {
            display: none;
          }
        }

        @media (max-width: ${MOBILE_WIDTH.toString()}px) {
          .hideDesktop {
            display: flex;
          }
        }

        @media (min-width: ${
          simplifiedDesktopHeader
            ? /* burger menu on enter/home page to reduce distractions */ '3000px'
            : `${HOME_PAGE_BREAK_POINT}px`
        }) {
          .menuLink.hideOnWideWidth,
          :global(.roundedButton.enterButton.hideOnWideWidth) {
            display: none;
          }

          .hiddenOnMobile {
            display: none;
          }
        }

        .barLinks.mobile > .centerBarLinks {
          opacity: 0.01;
          width: 1px;
          height: 1px;
          pointer-events: none;
        }

        .barLinks.mobile > .centerBarLinks.centerBarLinksVisible {
          width: auto;
          height: auto;
          opacity: 1;
          pointer-events: auto;
        }

        .desktopHeaderLink {
          cursor: pointer;
          font-size: 1.1em;
          margin-right: 2em;
          transition: 0.3s;
          color: ${isHeaderTransparent ? 'white' : colors.primaryBrandGray};
          text-transform: uppercase;
        }

        .desktopHeaderLink.highlighted {
          text-shadow: 0 0 5px ${colors.brand.neon};
          transition: 0.3s;
        }

        .expandableMenu {
          position: absolute;
          display: block;
          background-color: white;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 4px 4px 1px rgba(55, 55, 55, 0.4);
          border-radius: 0 0 8px 8px;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-content: center;
          right: 0;
          font-size: 15px;
        }

        @media (min-width: 600px) {
          .expandableMenu {
            position: absolute;
            max-width: 450px;
          }
        }

        .expandableMenu,
        .expandableMenu > * {
          flex-shrink: 0;
          width: 100%;
        }

        .covidBlogPostLink {
          background-color: #e1e1e1;
          color: ${colors.primaryBrandGray};
          font-style: italic;
          font-weight: 700;
          cursor: pointer;
          width: 98%;
          flex-shrink: 0;
          padding: 1em;
          text-align: center;
          border-radius: 4px;
          margin-bottom: 1em;
          display: flex;
          justify-content: center;
        }

        .covidBlogPostLink:hover {
          background-color: #cdcdcd;
        }

        :global(.menuLink) {
          cursor: pointer;
          display: inline-block;
          font-family: 'Montserrat', sans-serif !important;
          font-weight: 900;
          letter-spacing: 0;
          padding-left: 1em;
          text-align: left;
          margin: 0.7em 0;
          font-size: 15px;
        }

        :global(.menuLink.nonbold) {
          font-weight: 600;
        }

        :global(.subSectionLink) {
          text-transform: none;
          font-style: italic;
          font-weight: 600;
          padding-left: 1em;
        }

        :global(.menuLink:hover),
        :global(.subSectionLink:hover) {
          color: black;
        }

        a {
          text-align: left;
          margin: 0;
          padding: 0.5em;
          border-radius: 4px;
        }

        .logoImage {
          height: 40px;
          width: auto;
          cursor: pointer;
          vertical-align: middle;
        }

        // Attempts to solve blurry logo issue Abbi experiences
        @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
          .logoImage {
            image-rendering: -webkit-optimize-contrast !important;
          }
        }

        /* Unset for Safari 11+ */
        @media not all and (min-resolution: 0.001dpcm) {
          @supports (-webkit-appearance: none) and (stroke-color: transparent) {
            .logoImage {
              image-rendering: unset !important;
            }
          }
        }

        .withoutName {
          width: 49px;
          overflow: hidden;
        }
        .withoutName.withHalloween {
          width: 40px;
        }
        .withoutName.withChristmas {
          width: 49px;
        }

        .fullLogo.hidden {
          display: none;
        }

        .noTextLogo.hidden {
          display: none;
        }

        :global(.enterDrawButton.hidden) {
          display: none !important;
        }

        :global(.headerIcon) {
          color: #4a4a4a;
        }

        :global(.headerIcon:hover) {
          cursor: pointer;
          color: black;
          transition: 0.2s;
        }

        .headerContent {
          flex-direction: column;
        }

        .barLinks {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .expandableMenu {
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-content: center;
          right: 0;
        }

        .hidden {
          display: none;
        }

        .centralLinks :global(a),
        .expandableMenu :global(a) {
          width: 100%;
        }

        :global(.roundedButton.enterButton) {
          display: block !important;
          margin: 1.5em auto;
          max-width: 300px;
          width: 100%;
        }

        .referralsLink {
          display: block;
        }

        :global(.nextWinnerBanner.hidden) {
          opacity: 0;
          transform: scale(0.9);
          transition: 0.2s;
        }

        .accountMenu {
          padding: 0 1em;
        }

        :global(.accountMenu .upgradeCard) {
          margin: 0.5em 0;
        }

        :global(.headerIconWithBadge) {
          margin: 0 0.5em;
        }

        @media (min-width: 600px) {
          .accountMenu,
          .searchPanel {
            max-width: 450px;
          }
        }

        @media (max-width:767px) {
          .hideOnMobile.headerContainer {
            display: none;
          }
          .hideOnMobile.contentPadder {
            display: none;
        }

      `}</style>

      {expandedMenu !== null && (
        <div
          id="dimmedBackground"
          onClick={handleDismissExpandedMenu}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(55,55,55,0.3)',
            zIndex: 4,
          }}
        />
      )}
    </>
  );
});

export default Header;
